import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteAddUploadFileExpense } from "../../../data/usecases/expense-dashboard/remote-add-upload-file-expense";
import { AddReadFileExpenseType } from "../../../domain/useages/expense-dashboard/add-read-file-expense";
import { RemoteAddReadFileExpense } from "../../../data/usecases/expense-dashboard/remote-add-read-file-expense";

export interface AddReadFileExpenseInterface {
  AddReadFileExpenseState: FetchState;
  addReadFileExpense: Function;
}

const initialStates = {
  AddReadFileExpenseState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useAddReadFileExpenseSlice: StateCreator<
  AddReadFileExpenseInterface
> = (set, get) => ({
  ...initialStates,
  addReadFileExpense: async (
    payload: AddReadFileExpenseType.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddReadFileExpense =
      new RemoteAddReadFileExpense(
        `${BASE_URL}${Endpoints.ADD_READ_FILE_EXPENSE}`,
        axiosHttpClient
      );

    let result = await remoteAddReadFileExpense.add(payload);
    return result;
  },
});
